module.exports = __webpack_public_path__ + "static/media/certificate-icon.4a62ee72.svg";